import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "16", y1: "2", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "8", y1: "2", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "10", y2: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "22", y1: "19", y2: "19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CalendarMinus";
const CalendarMinus = memo(themed(Icon));
export {
  CalendarMinus
};
//# sourceMappingURL=calendar-minus.js.map
